import type { IconProps } from '../types/IconProps.ts';
export const FingerPrint: IconProps = {
    name: 'FingerPrint',
    children: [
        `<path d="M20 6c-1.61-2.43-4.87-4-8-4C7.03 2 2 5 2 12M2 16v3M21.5 10c.5 1.5.5 5 .5 7M17.78 10.5q.21.75.22 1.5v8" />`,
        `<path d="M15 6.87A5.7 5.7 0 0 0 12 6a6.1 6.1 0 0 0-5.11 3M6 13v7M10 22v-3M14 22v-5m-4-2v-3a2 2 0 1 1 4 0v1" />`,
    ]
};